import "./ConfirmCompleteTask.scss";
import { useTranslation } from "react-i18next";

function ConfirmCompleteTask({ incompleteCount, onConfirm, onCancel }) {
  const { t } = useTranslation();
  return (
    <div className="confirm-complete-task-content">
      <div className="modal-title">
        <div>{t("tasks.modals.confirmCompleteTask.title")}</div>
      </div>
      <div className="modal-body">
        <p>
          {t("tasks.modals.confirmCompleteTask.message", {
            count: incompleteCount,
          })}
        </p>
      </div>
      <div className="modal-form-buttons">
        <button className="modal-button cancel" onClick={onCancel}>
          {t("common.cancel")}
        </button>
        <button className="modal-button confirm" onClick={onConfirm}>
          {t("tasks.modals.confirmCompleteTask.confirm")}
        </button>
      </div>
    </div>
  );
}

export default ConfirmCompleteTask;
